import { Component } from "react";
import { bindActionCreators } from 'redux';
import { setAuthStarted } from '@/actions/auth'
import { setCheckoutOverlay } from "@/actions/ui";
import { reservationActive } from "@/selectors/reservation";
import { deleteReservation } from "@/actions/reservation";
import { connect } from "react-redux";
import Translation from '@s/Translation';
import { withNavigation } from '@b/helpers/withNavigation';

class AuthCloseButton extends Component {
  onCancel = () => {
    this.props.setAuthStarted(false);
    this.props.navigate('/');
    if (this.props.active) {
      this.props.deleteReservation();
    }
    this.props.setCheckoutOverlay(false);
  }

  render() {
    return (
      <button
        onClick={this.onCancel}
        className="button--secondary button--close">
        <i className="icon-close" aria-hidden="true"></i><span className="sr-only">
        <Translation>{'checkout__close'}</Translation></span>
      </button>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    active: reservationActive(state),
  }
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    deleteReservation,
    setAuthStarted,
    setCheckoutOverlay,
  }, dispatch);
};

export default withNavigation(connect(mapStateToProps, mapDispatchToProps)(AuthCloseButton));